import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';


const tourConfig = [
  {
    selector: '[data-tut="reactour"]',
    content: (
      <React.Fragment>
        Já sabe por onde começar?
        <Button
          href="https://support.puntu.digital/"
          color="primary"
          target="_blank"
        >
        Ver o passo a passo
        </Button>
        <Button
          component={Link}
          to="/funcionarios/cadastrar"
          color="primary"
        >
        Cadastrar funcionário
        </Button>
      </React.Fragment>
    ),
  },
  {
    selector: '[data-tut="reactour__departamento"]',
    content: 'Aqui podemos filtrar as informações por departamento  ',
  },
  {
    selector: '[data-tut="reactour__pontualidade"]',
    content: 'Aqui vemos as informações de pontualidade diária de seus funcionários',
  },
  {
    selector: '[data-tut="reactour__Mapa"]',
    content:
    'Acompanhe os colaboradores que registram ponto fora do local',
  },
];

export default tourConfig;
